import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {ConsolidatedCommissionsService} from "../../services/consolidated-commissions-service.service";
import {CommissionStatusType} from "../../types/commission-status.type";
import {ConsolidatedCommissionModel} from "../../models/consolidated-commission.model";
import {CommissionPaymentDetailsModel} from "../../models/commission-payment-details.model";
import {
  ExportConsolidatedCommissionTablePayloadModel
} from "../../models/consolidated-commission-table-export-payload.model";
import {
  ExportConsolidatedCommissionsTranslationsPayloadModel
} from "../../types/export-consolidated-commissions-translations-payload.model";
import {CommissionsDialogService} from "../../services/commissions-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {CommissionDateType} from "../../types/commission-date.type";

export class ConsolidatedCommissionsViewCtrl implements IController {
  accountId: any;
  from: any;
  to: any;
  filterDateType?: CommissionDateType;
  selectedConsolidatedCommission: ConsolidatedCommissionModel;
  isPaymentFailed : boolean;

  public selectedIds: string[] = [];
  public excludeMode: boolean = false;
  private consolidatedCommissionRef: any;
  public selectedStatus: CommissionStatusType;
  public filtersConfig: any;
  public queryString: string;
  public statusOptions: CommissionStatusType[] = Object.values(CommissionStatusType);
  public dateTypes: typeof CommissionDateType = CommissionDateType;

  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private confirmDialogService: ConfirmDialogService, private splitService,
              private commissionsDialogService: CommissionsDialogService, private $consolidatedCommission, private $scope: IScope,
              private consolidatedCommissionsService: ConsolidatedCommissionsService, private $translate) {
  }

  $onInit() {
    this.selectedStatus = undefined;
    this.filtersConfig = {
      bringozFilters: {
        accountId: this.accountId,
        statuses: []
      },
      filterDateType: this.filterDateType || CommissionDateType.CREATED_AT,
      customTemplates: this.dateRangeTimeFiltersService.getCommissionsCustomTemplates(),
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.thisMonth(),
      isPaymentFailed: this.isPaymentFailed
    };
    if (this.selectedConsolidatedCommission) {
      this._bindSelectedConsolidatedCommission(this.selectedConsolidatedCommission.id);
    }
  }

  $onDestroy() {
    this._destroySelectedConsolidatedCommissionRef();
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

  onRangeChanged(range) {
    this.filtersConfig.range = range;
    this._setQueryParams();
  }

  onStatusChange(status: CommissionStatusType) {
    this.selectedStatus = status;
    this.filtersConfig.bringozFilters.statuses = status ? [status] : undefined;
    this._setQueryParams();
  }

  onAccountSelect(accountId) {
    this.filtersConfig.bringozFilters.accountId = accountId;
    this._setQueryParams();
  }

  onFilterDateTypeChange(filterDateType: CommissionDateType) {
    this.filtersConfig.filterDateType = filterDateType;
    this._setQueryParams();
  }

  onHasPriceStatusChange(hasPrice) {
    this.filtersConfig.hasPrice = !hasPrice;
    this._setQueryParams();
  }

  onSelectedIdsChange(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    this.excludeMode = excludeMode;
  }

  onPaymentFailed(isPaymentFailed: boolean) {
    this.filtersConfig.isPaymentFailed = !isPaymentFailed;
    this._setQueryParams();
  }

  onExportTable() {
    const payload: ExportConsolidatedCommissionTablePayloadModel = this._getExportTablePayload();
    this.consolidatedCommissionsService.exportTableCSV(payload);
  }

  onExportCSV(consolidatedCommission: ConsolidatedCommissionModel) {
    const zoneId = this.splitService.getTimeZone();
    const payload: ExportConsolidatedCommissionsTranslationsPayloadModel = this._getExportPayload();
    this.consolidatedCommissionsService.exportCSV(consolidatedCommission.id, payload, zoneId);
  }

  onViewConsolidatedCommission(consolidatedCommission) {
    this._destroySelectedConsolidatedCommissionRef();

    this.selectedConsolidatedCommission = consolidatedCommission;
    this._bindSelectedConsolidatedCommission(consolidatedCommission.id);
    this._setQueryParams();
  }

  onAddCommissionsToConsolidatedCommission(consolidatedCommission) {
    this.commissionsDialogService.addCommissionsToConsolidatedOrder(consolidatedCommission.accountReference.id)
      .then((commissionsIdsToAdd) => {
        const payload = {
          commissionIds: commissionsIdsToAdd
        }
        this._addCommissions(consolidatedCommission.id, payload);
      })
  }

  onMarkAsPaid(consolidatedCommission: ConsolidatedCommissionModel) {
    this.commissionsDialogService.payManually(consolidatedCommission.name, consolidatedCommission.paymentDetails, consolidatedCommission.totalCommission)
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {
        this._markAsPaid(consolidatedCommission.id, commissionPaymentDetails);
      })
  }

  onPay(consolidatedCommission: ConsolidatedCommissionModel) {
    this.commissionsDialogService.payManually(consolidatedCommission.name, consolidatedCommission.paymentDetails, consolidatedCommission.totalCommission)
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {
        this._pay(consolidatedCommission.id, commissionPaymentDetails);
      })
  }

  onAttachFile(consolidatedCommission: ConsolidatedCommissionModel) {
    this.commissionsDialogService.attachFile(consolidatedCommission.name, consolidatedCommission.paymentDetails)
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {
        const consolidatedToUpdate = angular.copy(consolidatedCommission);
        consolidatedToUpdate.paymentDetails = commissionPaymentDetails;

        this._update(consolidatedCommission.id, consolidatedToUpdate);
      })
  }

  onRemoveCommissionsFromConsolidatedCommission(consolidatedCommission) {
    // this._removeCommissions(commissions);
  }

  onDeleteConsolidatedCommission(consolidatedCommission, $event) {
    const text = 'Are you sure you want to delete Carrier Payments';
    this.confirmDialogService.confirm('Delete Carrier Payment', text, $event)
      .then(() => {
        this._deleteConsolidatedCommission(consolidatedCommission.id)
      })
  }

  onBackToList() {
    this.selectedConsolidatedCommission = undefined;
    this._destroySelectedConsolidatedCommissionRef();
    this._setQueryParams();
  }

  onEditBillingOrder(consolidatedBillingOrder) {
    // this.BillingAccountDialogService.editConsolidatedBillingOrder(consolidatedBillingOrder)
    //   .then((payload) => {
    //     this._updateConsolidatedBillingOrder(consolidatedBillingOrder.id, payload.add, payload.remove);
    //   })
  }

  private _deleteConsolidatedCommission(consolidatedCommissionId) {
    this.consolidatedCommissionsService.delete(consolidatedCommissionId)
      .then((res) => {
        this._setQueryParams();
        this._refreshTable();
      })
  }

  private _addCommissions(consolidatedCommissionId, payload) {
    this.consolidatedCommissionsService.addCommissions(consolidatedCommissionId, payload)
      .then((updatedConsolidatedCommission) => {
        this._setQueryParams();
        this._refreshTable();
      })
  }

  private _removeCommissions(consolidatedCommissionId, commissions) {
    this.consolidatedCommissionsService.removeCommissions(consolidatedCommissionId, _.map(commissions, 'id'))
      .then((updatedConsolidatedCommission) => {
        this._setQueryParams();
        this._refreshTable();
      })
  }

  private _bindSelectedConsolidatedCommission(consolidatedCommissionId) {
    this.consolidatedCommissionRef = this.$consolidatedCommission(consolidatedCommissionId);
    this.consolidatedCommissionRef.$bindCtrl(this.$scope, this, 'selectedConsolidatedCommission');
  }

  private _destroySelectedConsolidatedCommissionRef() {
    if (this.consolidatedCommissionRef) {
      this.consolidatedCommissionRef.$destroy();
      this.consolidatedCommissionRef = undefined;
    }
  }

  private _markAsPaid(consolidatedCommissionId, commissionPaymentDetails: CommissionPaymentDetailsModel) {
    this.consolidatedCommissionsService.payManually(consolidatedCommissionId, commissionPaymentDetails)
      .then((updatedConsolidatedCommission) => {
        // this.consolidatedCommission = updatedConsolidatedCommission;
        // this._refreshCommissions();
      })
  }

  private _pay(consolidatedCommissionId, commissionPaymentDetails: CommissionPaymentDetailsModel) {
    this.consolidatedCommissionsService.pay(consolidatedCommissionId, commissionPaymentDetails)
      .then((updatedConsolidatedCommission) => {
        // this.consolidatedCommission = updatedConsolidatedCommission;
        // this._refreshCommissions();
      })
  }

  private _update(consolidatedCommissionId, consolidatedCommission: ConsolidatedCommissionModel) {
    this.consolidatedCommissionsService.update(consolidatedCommissionId, consolidatedCommission)
      .then((updatedConsolidatedCommission) => {
        // this.consolidatedCommission = updatedConsolidatedCommission;
        // this._refreshCommissions();
      })
  }


  private _refreshTable() {
    this.filtersConfig.bringozFilters = angular.copy(this.filtersConfig.bringozFilters);
  }

  private _setQueryParams() {
    this.$state.go('.', {
      accountId: this.filtersConfig.bringozFilters.accountId,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      filterDateType: this.filtersConfig.filterDateType,
      statuses: this.filtersConfig.bringozFilters.statuses,
      isPaymentFailed: this.filtersConfig.isPaymentFailed,
      consolidatedId: _.get(this.selectedConsolidatedCommission, 'id')
    }, {
      notify: false,
      reload: false
    })
  }

  private _getExportTablePayload() {
    const zoneId = this.splitService.getTimeZone();
    const payload: ExportConsolidatedCommissionTablePayloadModel = {
      fieldTranslationMap: {
        docDate: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.docDate'),
        name: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.name'),
        carrier: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.carrier'),
        numberOfCommissions: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.numberOfCommissions'),
        createdAt: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.createdAt'),
        status: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.status'),
        invoiceId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.invoiceId'),
        paymentMethod: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.paymentMethod'),
        totalAmount: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSIONS_TABLE_COLUMNS.totalAmount')
      },
      zoneId: zoneId
    }

    if (this.excludeMode) {
      _.set(payload, 'accountId', this.filtersConfig.bringozFilters.accountId);
      _.set(payload, 'fromDate', this.filtersConfig.range.dateStart);
      _.set(payload, 'filterDateType', this.filtersConfig.filterDateType);
      _.set(payload, 'toDate', this.filtersConfig.range.dateEnd);
      _.set(payload, 'statuses', this.filtersConfig.bringozFilters.statuses);
      _.set(payload, 'searchTerm', this.queryString);
      _.set(payload, 'excludeIds', this.selectedIds);
      _.set(payload, 'isLastPaymentFailed', this.filtersConfig.isPaymentFailed ? true : undefined);
    } else {
      _.set(payload, 'ids', this.selectedIds);
    }

    return payload;
  }

  private _getExportPayload(): ExportConsolidatedCommissionsTranslationsPayloadModel {
    return {
      accountName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.accountName'),
      packageBarcodes: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.packageBarcodes'),
      packageNames: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.packageNames'),
      agentId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.agentId'),
      agentName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.agentName'),
      serviceId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.serviceId'),
      serviceExternalId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.serviceExternalId'),
      createdAt: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.createdAt'),
      updatedAt: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.updatedAt'),
      pickupAddress: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.pickupAddress'),
      dropoffAddress: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.dropoffAddress'),
      timeWindow: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.timeWindow'),
      paymentType: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paymentType'),
      amount: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.amount'),
      manualAmount: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.manualAmount'),
      servicePrice: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.servicePrice'),
      paymentAdditionalInfo: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paymentAdditionalInfo'),
      paidDate: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paidDate'),
      madeBy: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.madeBy'),
      paidManually: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paidManually')
    }
  }

}

angular
  .module('bringoz.admin.commissions')
  .component('consolidatedCommissionsView', {
    bindings: {
      accountId: '<?',
      from: '<?',
      to: '<?',
      filterDateType: '<?',
      isPaymentFailed: '<?',
      selectedConsolidatedCommission: '<?'
    },
    template: require('./consolidated-commissions-view.html').default,
    controller: ConsolidatedCommissionsViewCtrl
  });
